import { getProductGroupListData } from '../productGroups/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { IEntitySelectItem, TEntityId } from '~/types/models'
import type {
  IProductSubcategory,
  IProductSubcategoryOverview,
  IProductGroup,
} from '~/types/product/models'

const productSubcategoryListData = undefined as unknown as IProductSubcategory[]

export const getProductSubcategoryListData = getListDataFunctionFactory<
  IProductSubcategory[]
>({
  listData: productSubcategoryListData,
  storageKey: 'productsubcategories',
  getStartingListData: getStartingProductSubcategoryListData,
})

export function _getPRSCDataById(
  id: TEntityId,
  list: IProductSubcategory[]
): IProductSubcategory {
  if (!list) {
    throw new Error(`_getPRSCDataById called with undefined/null list`)
  }
  const productSubcategory = list.find((p: IProductSubcategory) => p.id === id)
  if (!productSubcategory) {
    throw new Error(`Can't find productSubcategory '${id}'`)
  }
  return productSubcategory
}

export async function getProductSubcategoryDataById(
  id: string
): Promise<IProductSubcategory> {
  const list: IProductSubcategory[] = await getProductSubcategoryListData()
  return _getPRSCDataById(id, list)
}

export function _getPRSCSelectItemDataById(
  id: TEntityId,
  list: IProductSubcategory[]
): IEntitySelectItem {
  if (!list) {
    throw new Error(
      `_getPRSCSelectItemDataById called with undefined/null list`
    )
  }
  const productSubcategory = _getPRSCDataById(id, list)
  return { id: productSubcategory.id, label: productSubcategory.descr }
}

export async function getProductSubcategorySelectDataById(
  id: string
): Promise<IEntitySelectItem> {
  const psc = await getProductSubcategoryDataById(id)
  return { id: psc.id, label: psc.descr }
}

export async function getProductGroupsData(
  id: string
): Promise<IProductGroup[] | undefined> {
  const list = await getProductGroupListData()
  return list.filter(
    (productGroup: IProductGroup) => productGroup.productSubcategory.id === id
  )
}

export async function getProductSubcategoryOverviewData(
  id: string
): Promise<IProductSubcategoryOverview | undefined> {
  const list = await getProductSubcategoryListData()
  const productSubcategoryData = list.find(
    (productSubcategory: IProductSubcategory) => productSubcategory.id === id
  )
  if (!productSubcategoryData) {
    return undefined
  }
  const productGroupsData = (await getProductGroupsData(id)) || []
  const overviewData = {
    productSubcategory: productSubcategoryData,
    productGroups: productGroupsData,
  }
  console.debug(overviewData)
  return overviewData
}

export async function getStartingProductSubcategoryListData(): Promise<
  IProductSubcategory[]
> {
  return [
    {
      id: 'XXPRSC0001',
      hrid: 'PRSC0001',
      productCategory: { id: 'XXPRC0001', label: 'Connectivity' },
      descr: 'Internet Access',
      numItems: 2,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRSC0002',
      hrid: 'PRSC0002',
      productCategory: { id: 'XXPRC0001', label: 'Connectivity' },
      descr: 'WAN',
      numItems: 2,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRSC0003',
      hrid: 'PRSC0003',
      productCategory: { id: 'XXPRC0001', label: 'Connectivity' },
      descr: 'Transport',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRSC0004',
      hrid: 'PRSC0004',
      productCategory: { id: 'XXPRC0002', label: 'Voice & Collaboration' },
      descr: 'Cloud Voice',
      numItems: 3,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRSC0005',
      hrid: 'PRSC0005',
      productCategory: { id: 'XXPRC0003', label: 'Services' },
      descr: 'Professional Services',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPRSC0006',
      hrid: 'PRSC0006',
      productCategory: { id: 'XXPRC0003', label: 'Services' },
      descr: 'General',
      numItems: 1,
      version: '1',
      canBeDeleted: false,
    },
  ]
}
